import { useEffect, useState } from 'react';

import { getViewedListings } from './viewedListings';

/**
 * Read hook for the buyer-facing "Viewed" marker.
 *
 * Returns a Set of viewed listing uuids. SSR-safe: returns an EMPTY set on the
 * server and on the first client render (it never reads localStorage during
 * render), then loads getViewedListings() into state in a mount effect. This
 * keeps the server HTML and the first client render identical — no hydration
 * mismatch — and reveals the markers after mount. This is the only way the
 * grids learn the viewed set.
 *
 * Read once at grid level and passed down as an `isViewed` boolean per card,
 * so a grid of N cards performs a single localStorage read (not N).
 *
 * @returns {Set<string>} viewed listing uuids (empty until after mount)
 */
const useViewedListings = () => {
  const [viewed, setViewed] = useState(() => new Set());

  useEffect(() => {
    setViewed(new Set(getViewedListings()));
  }, []);

  return viewed;
};

export default useViewedListings;
